<template>
  <div class="appointment-wrapper">
    <div class="header">
      <div class="meta">
        <div class="name">{{ service.name }}</div>
        <p v-if="service.shortDescription" class="desc mt-2">
          {{ service.shortDescription }}
        </p>
        <p v-if="service.mainOption" class="mt-2">
          Option หลัก: {{ service.mainOption }}
        </p>
        <p v-if="service.extraOption">
          Option เสริม: {{ service.extraOption }}
        </p>
      </div>
      <div>
        <button
          v-if="isShowViewAllAppointmentBtn"
          class="button"
          @click="handleViewAllAppointment"
        >
          {{ "นัดหมายทั้งหมด" }}
        </button>
      </div>
    </div>
    <div class="content">
      <div class="item">
        <p v-if="isDesktop" class="title">{{ "สถานะงาน :" }}</p>
        <div class="status">
          <div :class="statusList" class="bullet"></div>
          <p>{{ statusText }}</p>
        </div>
      </div>
      <div class="item">
        <p class="title">{{ "ครั้งที่ :" }}</p>
        <p>{{ `${appointment.appointmentNo}/${appointment.quantity}` }}</p>
      </div>
      <div class="item remove-gap">
        <p class="title">{{ "นัดหมาย :" }}</p>
        <div v-if="isDesktop">
          <p :class="appointmentTimeStatusList">{{ dateText }}</p>
          <p :class="appointmentTimeStatusList">{{ timeText }}</p>
        </div>
        <p v-else :class="appointmentTimeStatusList">
          {{ `${dateText} ${timeText}` }}
        </p>
      </div>
      <div class="note">
        <p class="title">{{ "หมายเหตุลูกค้า :" }}</p>
        <p>{{ appointment.note }}</p>
      </div>
    </div>
    <div class="button-wrapper">
      <button
        v-if="canConfirm"
        class="button"
        @click="handleClickConfirmAppointment"
      >
        {{ "ยืนยัน" }}
      </button>
      <!-- Open the button when the user requests it -->
      <!-- <button
        class="button"
        @click="handleClickConfirmAppointment"
        v-if="canChangeDate"
      >
        {{ "เปลี่ยนวันนัด" }}
      </button> -->
      <button
        v-if="canProviderFulfill"
        class="button"
        @click="handleClickFulfillAppointment"
      >
        {{ "ปิดงาน" }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  toLocaleTH,
  getDurationAppointmentTimeText,
  getAppointmentTimeText,
} from "@/lib/dateTime"
import { DateTime } from "luxon"
import { mlSize } from "../StaticVariable"

export default {
  props: {
    appointment: {
      type: null,
      default: undefined,
    },
    service: {
      type: null,
      default: undefined,
    },
    isShowViewAllAppointmentBtn: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mlSize
    },
    canConfirm() {
      return this.appointment.constraint.canConfirm
    },
    canChangeDate() {
      return (
        this.appointment.constraint.canChangeDate &&
        this.appointment.status !== "CANCELLED"
      )
    },
    canProviderFulfill() {
      return this.appointment.constraint.canProviderFulfill
    },
    dateTimeTH() {
      if (!this.appointment.dateTime) return null
      return toLocaleTH(DateTime.fromISO(this.appointment.dateTime))
    },
    dateText() {
      return this.dateTimeTH.toFormat("dd MMM yyyy")
    },
    timeText() {
      const appointmentDurationTime = getDurationAppointmentTimeText(
        this.appointment.dateTime || null,
        this.appointment.dateTimeEnd || null,
      )
      if (appointmentDurationTime) return appointmentDurationTime

      return getAppointmentTimeText(this.appointment.dateTime)
    },
    statusText() {
      const statusMap = {
        CREATED: "นัดใหม่",
        CANCELLED: "ยกเลิก",
        CONFIRMED: "ยืนยัน",
        WAIT_CONFIRMED_SERVICE_COMPLETE: "รอรับบริการ",
        PROVIDER_FULFILLED: "ช่างปิดงาน",
        FULFILLED: "เสร็จสิ้น",
      }

      return statusMap[this.appointment.status]
    },
    appointmentTimeStatusList() {
      return [`time_${this.appointment.status.toLowerCase()}`]
    },
    statusList() {
      return [this.appointment.status.toLowerCase()]
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    handleClickConfirmAppointment() {
      this.$emit("showAppointment", true)
    },
    handleClickFulfillAppointment() {
      this.$emit("showFulfillAppointment", true)
    },
    handleViewAllAppointment() {
      this.$emit("viewAllAppointment", true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";

.appointment-wrapper {
  display: flex;
  flex-direction: column;
  border: 2px solid $supplier-primary-color;
  border-radius: 8px;
  background-color: $white;
  overflow: hidden;

  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 24px;
    background-color: #5175e11a;

    .meta {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      padding-right: 16px;

      > .name {
        color: $black;
        font-size: 18px;
        font-weight: bold;
      }

      > .desc {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

    .meta p {
      line-height: 1.6;
      font-size: 14px;
      color: #606060;
    }

    .button {
      width: 150px;
      height: 40px;
      font-weight: bold;
      font-size: $font-14;
      border-radius: 8px;
      color: $supplier-primary-color;
      background: $white;
      border: 1px solid #d9d9d9;

      &:hover:not(:disabled) {
        background: #fafafa;
      }
    }
  }

  > .content {
    display: grid;
    grid-template-columns:
      calc(15% - 6px) calc(15% - 6px)
      calc(30% - 6px) calc(40% - 6px);
    grid-gap: 12px;
    padding: 8px 24px 0 24px;

    > .item {
      display: flex;
      flex-direction: column;

      > .title {
        font-size: 14px;
        color: #808080;
        padding-bottom: 8px;
      }

      > .status {
        display: flex;
        flex-direction: row;
        align-items: center;

        > .bullet {
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }

        p {
          color: $black;
          margin-left: 8px;
          font-size: 16px;
        }

        & .created {
          background-color: $secondary-color;
        }

        & .cancelled {
          background-color: $danger-color;
        }

        & .confirmed,
        & .wait_confirmed_service_complete {
          background-color: $warning-color;
        }

        & .provider_fulfilled {
          background-color: $success-dark-color;
        }

        & .fulfilled {
          background-color: $success-color;
        }
      }

      > .appointment-date {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      p {
        font-size: $font-16;
      }
    }

    > .note {
      display: flex;
      flex-direction: column;

      > .title {
        font-size: 14px;
        color: #808080;
      }

      p {
        font-size: $font-16;
      }
    }
  }

  > .button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 0 16px 16px 0;

    > .button {
      width: 124px;
      height: 44px;
      font-weight: bold;
      font-size: $font-16;
      border-radius: 8px;
      color: $white;
      background: $supplier-primary-color;
      border: none;

      &:hover:not(:disabled) {
        background: $supplier-primary-light-color;
      }
    }
  }
}

.time_created,
.time_confirmed,
.time_wait_confirmed_service_complete {
  color: $primary-color;
}

@media (max-width: ($m-size - 1)) {
  .appointment-wrapper {
    > .header {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 12px 16px;

      .meta {
        padding-right: 0;
      }

      .button {
        margin-top: 12px;
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      grid-gap: 8px;

      > .item {
        > .title {
          padding-bottom: 0;
        }
      }

      > .note {
        width: 100%;
        background-color: #f6f6f6;
        border-radius: 8px;
        padding: 8px 16px;

        > .item {
          display: flex;
          flex-direction: row;
          align-items: center;
          grid-gap: 12px;
        }

        p {
          font-size: $font-14;
        }
      }

      > .remove-gap {
        margin-top: -8px;
      }
    }

    > .button-wrapper {
      padding: 0 24px 24px 24px;

      > .button {
        width: 100%;
      }
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .appointment-wrapper {
    > .header {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 12px 16px;

      .meta {
        padding-right: 0;
      }

      .button {
        margin-top: 12px;
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      grid-gap: 8px;
      padding: 16px;

      > .item {
        > .title {
          padding-bottom: 0;
        }
      }

      > .note {
        width: 100%;
        background-color: #f6f6f6;
        border-radius: 8px;
        padding: 8px 16px;

        > .item {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        p {
          font-size: $font-14;
        }
      }

      > .remove-gap {
        margin-top: -8px;
      }
    }

    > .button-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      padding: 0 16px 16px 16px;

      > .button {
        width: 100%;
      }
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .appointment-wrapper {
    > .header {
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 12px 16px;

      .meta {
        padding-right: 0;

        > .name {
          font-size: 16px;
        }
      }

      .meta p {
        font-size: 13px;
      }

      .button {
        width: 130px;
        height: 36px;
        margin-top: 12px;
        font-size: 12px;
      }
    }

    > .content {
      grid-template-columns:
        calc(18% - 4px) calc(15% - 4px)
        calc(30% - 4px) calc(37% - 4px);
      grid-gap: 8px;
      padding: 8px 16px 0 16px;

      > .item {
        > .title {
          font-size: 12px;
        }

        > .status {
          > .bullet {
            width: 14px;
            height: 14px;
          }

          p {
            margin-left: 6px;
            font-size: 14px;
          }
        }

        p {
          font-size: $font-14;
        }
      }
    }

    > .button-wrapper {
      > .button {
        width: 100px;
        height: 40px;
        font-size: $font-14;

        &:hover:not(:disabled) {
          background: $supplier-primary-light-color;
        }
      }
    }
  }
}
</style>
